import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Dropdown from 'react-bootstrap/Dropdown';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import styled from 'styled-components';

const StyledLabel = styled.span`
    font-size: 1.4rem;
    vertical-align: top;
    font-weight: bold;
    padding-right: 1%;
`;

const StyledItemDropdown = styled.span`
    font-size: 1.4rem;
    padding-right: 1%;
    color: black;
`;

function Gears({ brokerData, onSelectViewProfile, onSelectDedesignateAgent }) {

    const { name, contactNumber, title, pendingStatusMsg, currentStatusPending, deDesignateMsg, viewProfileTitle } = brokerData;

    const Title = () => (
        <span>
            <StyledLabel>{title}</StyledLabel>{'  '}
            <FontAwesomeIcon icon="cog" size="2x" />{'  '}
        </span>
    );

    return (
        <div className="grid-row gears float-right">
            <Dropdown as={ButtonGroup}>
                <Dropdown.Toggle id="dropdown-menu-align-right" variant="light" aria-haspopup="listbox"><Title /></Dropdown.Toggle>
                <Dropdown.Menu className="gears-item" role="listbox">
                    <Dropdown.Item eventKey="1" className="gears-item" role="option"><FontAwesomeIcon icon="user" size="1x" /> <StyledItemDropdown>{name}</StyledItemDropdown></Dropdown.Item>
                    <Dropdown.Item eventKey="2" role="option"><FontAwesomeIcon icon="phone-alt" size="1x" /> <StyledItemDropdown>{contactNumber}</StyledItemDropdown></Dropdown.Item>
                    {
                        pendingStatusMsg &&
                        <Dropdown.Item eventKey="noSelect" active role="option"><StyledItemDropdown>{pendingStatusMsg}{currentStatusPending}</StyledItemDropdown></Dropdown.Item>
                    }
                    <Dropdown.Item onClick={onSelectViewProfile} eventKey="viewProfile" role="option"><StyledItemDropdown>{viewProfileTitle}</StyledItemDropdown></Dropdown.Item>
                    {
                        deDesignateMsg &&
                        <Dropdown.Item onClick={onSelectDedesignateAgent} eventKey="dedesignateAgent" role="option"><StyledItemDropdown>{deDesignateMsg}</StyledItemDropdown></Dropdown.Item>
                    }
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
}

export default Gears;